import { zipWith } from 'lodash'

const getControlDigit = (valueDigits: number[], factors: number[]) =>
    (zipWith(
        valueDigits.slice(0, factors.length),
        factors,
        (a, b) => a * b
    ).reduce((sum, v) => sum + v, 0) %
        11) %
    10

export type IndividualInnErrorKey =
    | 'invalid_length_12'
    | 'invalid_characters'
    | 'invalid_checksum'

export const validateIndividualInn = (
    value: string
): { valid: true } | { valid: false; error: IndividualInnErrorKey } => {
    /*
  https://info.gosuslugi.ru/articles/Валидация/
  */
    if (value.length !== 12) {
        return { valid: false, error: 'invalid_length_12' }
    }

    const valueDigits: number[] = []
    for (const char of value) {
        const a = parseInt(char)
        if (isNaN(a)) {
            return { valid: false, error: 'invalid_characters' }
        }
        valueDigits.push(a)
    }

    const firstControlDigit = getControlDigit(
        valueDigits,
        [7, 2, 4, 10, 3, 5, 9, 4, 6, 8]
    )
    const secondControlDigit = getControlDigit(
        valueDigits,
        [3, 7, 2, 4, 10, 3, 5, 9, 4, 6, 8]
    )

    if (
        firstControlDigit === valueDigits[10] &&
        secondControlDigit === valueDigits[11]
    ) {
        return { valid: true }
    }

    return { valid: false, error: 'invalid_checksum' }
}

export type CompanyInnErrorKey =
    | 'invalid_length_10'
    | 'invalid_characters'
    | 'invalid_checksum'

export const validateCompanyInn = (
    value: string
): { valid: true } | { valid: false; error: CompanyInnErrorKey } => {
    /*
  https://info.gosuslugi.ru/articles/Валидация/
  */
    if (value.length !== 10) {
        return { valid: false, error: 'invalid_length_10' }
    }

    const valueDigits: number[] = []
    for (const char of value) {
        const a = parseInt(char)
        if (isNaN(a)) {
            return { valid: false, error: 'invalid_characters' }
        }
        valueDigits.push(a)
    }

    const controlDigit = getControlDigit(
        valueDigits,
        [2, 4, 10, 3, 5, 9, 4, 6, 8]
    )

    if (controlDigit === valueDigits[9]) {
        return { valid: true }
    }

    return { valid: false, error: 'invalid_checksum' }
}
